export default "__VITE_ASSET__f52b74fa__"